import {RouteProps} from "react-router-dom";
import * as React from "react";
import {AppPermissions} from "../model/Group";

export enum routesPosition {
    leftSideBar,
    RightSideBar,
    hiddenRoutes
}
export interface RoutesProps {
    path?: RouteProps['path'];
    position: routesPosition;
    name?: string;
    element?: RouteProps['element'];
    caseSensitive?: RouteProps['caseSensitive'];
    icon?: string;
    header?: string;
    roles?: string[];
    children?: RoutesProps[];
    index?: RouteProps['index'];
    handle?: {
        crumb: string
    }
    errorElement?: React.ReactNode | null;
    accessControl?: Array<AppPermissions>
}

// flatten the list of all nested routes
const flattenRoutes = (routes: RoutesProps[]) => {
    let flatRoutes: RoutesProps[] = [];

    routes = routes || [];
    routes.forEach((item: RoutesProps) => {
        flatRoutes.push(item);

        if (typeof item.children !== 'undefined') {
            flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
        }
    });
    return flatRoutes;
};

const filterRoutes = (routes: RoutesProps[]) => {
    const filteredRoutes: RoutesProps[] = [];

    routes.filter((route) => route.path !== undefined)
        .filter((route) => route.name !== undefined)
        .map((route) => {
            return filteredRoutes.push(route);
        });
    return filteredRoutes;
}

const filterProtectedRoutes = (routes: RoutesProps[], userRoles: AppPermissions[]) => {
    const protectedRoutes = routes.filter((route) => route.path !== undefined)
        .filter((route) => route.name !== undefined)
        .filter(route => !route.accessControl || route.accessControl.some(routePermission => userRoles.includes(routePermission)));

    return protectedRoutes
}

export {flattenRoutes, filterRoutes, filterProtectedRoutes};